import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform<T>(items: T[] | undefined, property: string, order: 'asc' | 'desc'): T[] {
    if (items === undefined) {
      return []
    }
    return _.orderBy(items, [property], [order]);
  }

}
